import React from "react"
import '../../../Styles/tas/spinner.css';

export default function SpinnerComponent() {
    return (
        <div className={'item-spinner'}>
            <div className={'lds-dual-ring'}/>
        </div>
    )
}